<template>
  <div class="service-section">
    <div class="service-header">
      <h2 class="service-title">{{ $t('newServices.sectionTitle') }}</h2>
      <p class="service-subtitle">
        {{ $t('newServices.sectionSubtitle') }}
      </p>
    </div>
    <div class="service-grid">
      <div
        class="service-card"
        v-for="(item, index) in cards"
        :key="index"
        @click="handleNavigate"
      >
        <div class="card-icon" v-html="item.icon"></div>
        <h3 class="card-title">{{ item.title }}</h3>
        <p class="card-desc">{{ item.desc }}</p>
        <div class="card-action">
          <span>{{ $t('newServices.learnMore') }}</span>
          <span class="arrow">&rarr;</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  computed: {
    cards() {
      const c = this.$t('newServices.cards', { returnObjects: true });
      return Array.isArray(c) ? c : [];
    }
  },
  methods: {
    handleNavigate() {
      this.$router.push('/production/1').catch(() => {})
    },
  },
}
</script>

<style lang="scss" scoped>
/* General Section Styling */
.service-section {
  padding: 60px 20px;
  background-color: #f8f9fa;
  text-align: center;
}

.service-header {
  margin-bottom: 50px;
  max-width: 700px;
  margin-left: auto;
  margin-right: auto;
}

.service-title {
  font-size: 2.5rem;
  font-weight: 700;
  color: #1a202c;
  margin-bottom: 1rem;
}

.service-subtitle {
  font-size: 1.1rem;
  color: #4a5568;
  line-height: 1.6;
}

/* Grid Layout */
.service-grid {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 30px;
  max-width: 1280px;
  margin: 0 auto;
}

/* Card Styling */
.service-card {
  background: #ffffff;
  border-radius: 16px;
  padding: 32px;
  text-align: left;
  box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.05),
    0 2px 4px -2px rgba(0, 0, 0, 0.05);
  transition: transform 0.3s ease, box-shadow 0.3s ease;
  cursor: pointer;
  display: flex;
  flex-direction: column;
  align-items: center;
  position: relative;
  overflow: hidden;

  &::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: linear-gradient(
      134deg,
      #0649b8 1%,
      #0a7fd7 41%,
      #03d2c5 99%
    );
    opacity: 0;
    transition: opacity 0.5s ease;
    z-index: 1;
  }

  > * {
    position: relative;
    z-index: 2;
    transition: color 0.5s ease;
  }

  &:hover {
    transform: translateY(-8px);
    box-shadow: 0 20px 25px -5px rgba(0, 0, 0, 0.1),
      0 8px 10px -6px rgba(0, 0, 0, 0.1);

    &::before {
      opacity: 1;
    }

    .card-icon,
    .card-title,
    .card-desc,
    .card-action {
      color: #fff;
    }

    .card-icon {
      background: rgba(255,255,255,0.2);
      ::v-deep img {
        filter: hue-rotate(205deg) saturate(2.2) brightness(0.98)
          drop-shadow(0 6px 12px rgba(12, 59, 117, 0.28));
        transform: scale(1.02);
      }
    }

    .card-action .arrow {
      transform: translateX(5px);
    }
  }
}

.card-icon {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 72px;
  height: 72px;
  border-radius: 14px;
  background: linear-gradient(135deg, #e8f4fd 0%, #d0eaff 100%);
  margin-bottom: 20px;
  transition: background 0.5s ease;
  ::v-deep img {
    filter: hue-rotate(205deg) saturate(2.2) brightness(0.98);
    width: 64px;
    height: 64px;
    object-fit: contain;
    transition: transform 0.5s ease, filter 0.5s ease;
  }
}

.card-title {
  font-size: 1.4rem;
  font-weight: 600;
  color: #2d3748;
  margin-bottom: 12px;
}

.card-desc {
  font-size: 1rem;
  line-height: 1.6;
  color: #4a5568;
  flex-grow: 1;
  margin-bottom: 24px;
}

.card-action {
  font-size: 1rem;
  font-weight: 600;
  color: #0a7fd7;
  display: flex;
  align-items: center;
  margin-top: auto;

  .arrow {
    margin-left: 8px;
    transition: transform 0.3s ease;
  }
}

/* Responsive Adjustments */
@media (max-width: 768px) {
  .service-section {
    padding: 40px 15px;
  }

  .service-title {
    font-size: 2rem;
  }

  .service-grid {
    grid-template-columns: repeat(2, 1fr);
    gap: 16px;
  }
}

@media (max-width: 480px) {
  .service-grid {
    grid-template-columns: 1fr;
    gap: 18px;
  }
}
</style>
